<template>
  <a-card :bordered="false">
    <a-row :gutter="24">
      <a-col :span="24">
        <!-- 条件搜索区域 -->
        <div class="table-page-search-wrapper" :class="{ 'is-collapsed': !advanced }">
          <a-form layout="inline">
            <a-row :gutter="[16, 8]">
              <a-col :xxl="6" :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                <a-form-item label="规则名称" prop="name">
                  <a-input
                    v-model:value="queryParam.name"
                    placeholder="请输入"
                    allow-clear
                    class="no-border-radius-input"
                  />
                </a-form-item>
              </a-col>
              <a-col :xxl="6" :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                <a-form-item label="开始时间" prop="startTime">
                  <a-time-picker
                    v-model:value="queryParam.startTime"
                    placeholder="请选择开始时间"
                    style="width: 100%"
                    format="HH:mm"
                    valueFormat="HH:mm"
                    allow-clear
                    class="no-border-radius-picker"
                  />
                </a-form-item>
              </a-col>
              <a-col :xxl="6" :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                <a-form-item label="结束时间" prop="endTime">
                  <a-time-picker
                    v-model:value="queryParam.endTime"
                    placeholder="请选择结束时间"
                    style="width: 100%"
                    format="HH:mm"
                    valueFormat="HH:mm"
                    allow-clear
                    class="no-border-radius-picker"
                  />
                </a-form-item>
              </a-col>

              <!-- 按钮区域：默认在第一行，展开后在最后一行 -->
              <a-col v-if="!advanced" :xxl="6" :xl="8" :lg="12" :md="12" :sm="24" :xs="24" class="search-actions-col">
                <a-form-item>
                  <span class="table-page-search-submitButtons" :style="submitButtonStyle">
                    <a-button type="primary" @click="handleQuery" class="search-button">搜索</a-button>
                    <span class="search-actions-group">
                      <a-button @click="resetQuery" class="no-border-button">重置</a-button>
                      <a-button @click="toggleAdvanced" class="no-border-button toggle-button">
                        {{ advanced ? '收起' : '展开' }}
                        <UpOutlined v-if="advanced" />
                        <DownOutlined v-else />
                      </a-button>
                    </span>
                  </span>
                </a-form-item>
              </a-col>

              <template v-if="advanced">
                <a-col :xxl="6" :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                  <a-form-item prop="workingHours">
                    <template #label>
                      <span>每日工作时长</span>
                    </template>
                    <a-input
                      v-model:value="queryParam.workingHours"
                      placeholder="请输入工作时长(小时)"
                      allow-clear
                      class="no-border-radius-input"
                    />
                  </a-form-item>
                </a-col>
                <a-col :xxl="6" :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                  <a-form-item label="是否跨天" prop="isOvernight">
                    <a-select
                      v-model:value="queryParam.isOvernight"
                      placeholder="请选择"
                      allow-clear
                      style="width: 100%"
                      class="no-border-radius-select"
                    >
                      <a-select-option
                        v-for="(d, index) in dict.type['is_overnight']"
                        :key="d.value"
                        :value="d.value"
                        >{{ d.label }}</a-select-option
                      >
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :xxl="6" :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                  <a-form-item prop="workRules">
                    <template #label>
                      <span>工作天数规则</span>
                    </template>
                    <a-select
                      v-model:value="queryParam.workRules"
                      placeholder="请选择"
                      allow-clear
                      style="width: 100%"
                      class="no-border-radius-select"
                    >
                      <a-select-option
                        v-for="(d, index) in dict.type['working_days_rules']"
                        :key="d.value"
                        :value="d.value"
                        >{{ d.label }}</a-select-option
                      >
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :xxl="6" :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                  <a-form-item label="工作天数" prop="workingDays">
                    <a-input
                      v-model:value="queryParam.workingDays"
                      placeholder="请输入"
                      allow-clear
                      class="no-border-radius-input"
                    />
                  </a-form-item>
                </a-col>

                <!-- 展开后，按钮在最后一行 -->
                <a-col :xxl="6" :xl="8" :lg="12" :md="12" :sm="24" :xs="24" class="search-actions-col">
                  <a-form-item>
                    <span class="table-page-search-submitButtons" :style="submitButtonStyle">
                      <a-button type="primary" @click="handleQuery" class="search-button">搜索</a-button>
                      <span class="search-actions-group">
                        <a-button @click="resetQuery" class="no-border-button">重置</a-button>
                        <a-button @click="toggleAdvanced" class="no-border-button toggle-button">
                          {{ advanced ? '收起' : '展开' }}
                          <UpOutlined v-if="advanced" />
                          <DownOutlined v-else />
                        </a-button>
                      </span>
                    </span>
                  </a-form-item>
                </a-col>
              </template>
            </a-row>
          </a-form>
        </div>
        <!-- 操作按钮区域 -->
        <div class="table-operations">
          <a-button
            type="text"
            shape="circle"
            @click="getList"
            v-hasPermi="['system:attendance:refresh']"
            class="refresh-icon-button"
          >
            <img src="@/assets/images/projectUser/refresh.png" alt="刷新" />
          </a-button>
          <a-button
            type="primary"
            @click="$refs.createForm.handleAdd()"
            v-hasPermi="['system:attendance:add']"
            class="add-button"
          >
            <PlusOutlined />新增
          </a-button>

          <a-button
            @click="handleExport"
            v-hasPermi="['system:attendance:export']"
            class="no-border-button import-export-button"
          >
            <UploadOutlined />导出
          </a-button>
          <a-button
            @click="$refs.importExcel.importExcelHandleOpen()"
            v-hasPermi="['system:attendance:import']"
            class="no-border-button import-export-button"
          >
            <DownloadOutlined />导入
          </a-button>
          <a-button
            :disabled="multiple"
            @click="handleDelete"
            v-hasPermi="['system:attendance:remove']"
            class="no-border-button"
          >
            <DeleteOutlined />删除
          </a-button>
          <a-button
            @click="handleImportTemplate"
            v-hasPermi="['system:attendance:importTemplate']"
            class="no-border-button template-download-button"
          >
            <CloudDownloadOutlined />导入模板下载
          </a-button>
          <!-- <table-setting
            :style="{ float: 'right' }"
            v-model:table-size="tableSize"
            v-model:value="columns"
            :refresh-loading="loading"
            @refresh="getList"
          /> -->
        </div>
        <!-- 组件 -->
        <create-form ref="createForm" @ok="getList" @close="getList" />
        <import-excel ref="importExcel" @ok="getList" />
        <employee-list-modal v-model:visible="employeeListVisible" :attendance-id="currentAttendanceId" />
        <!-- 数据表格 -->
        <div style="margin-top: 20px">
          <a-table
            :loading="loading"
            :size="tableSize"
            rowKey="id"
            :columns="tableColumns"
            :data-source="list"
            :row-selection="{
              selectedRowKeys: selectedRowKeys,
              onChange: onSelectChange,
              fixed: true,
            }"
            :pagination="false"
            :bordered="tableBordered"
            :scroll="{ x: 2000 }"
            class="optimized-table"
          >
            <template #bodyCell="{ column, text, record, index }">
              <!-- 序号列 -->
              <template v-if="column.dataIndex === 'index'">
                <span>{{
                  (queryParam.pageNum - 1) * queryParam.pageSize +
                  (index !== undefined && index !== null ? index : list.findIndex((item) => item.id === record.id)) +
                  1
                }}</span>
              </template>
              <!-- 开始时间 -->
              <template v-if="column.dataIndex === 'startTime'">
                <span>
                  {{ formatTime(record.startTime) }}
                </span>
              </template>
              <!-- 结束时间 -->
              <template v-else-if="column.dataIndex === 'endTime'">
                <span>
                  {{ formatTime(record.endTime) }}
                </span>
              </template>
              <!-- 是否跨天 -->
              <template v-else-if="column.dataIndex === 'isOvernight'">
                {{ text === 0 || text === '0' ? '否' : '是' }}
              </template>
              <!-- 工作天数规则 -->
              <template v-else-if="column.dataIndex === 'workRules'">
                <span v-if="text === 0 || text === '0'">月</span>
                <span v-else-if="text === 1 || text === '1'">周</span>
                <span v-else-if="text === 2 || text === '2'">双日</span>
                <span v-else-if="text === 3 || text === '3'">三日</span>
                <span v-else>{{ text }}</span>
              </template>
              <!-- 创建时间 -->
              <template v-else-if="column.dataIndex === 'createTime'">
                <span>
                  {{ parseTime(record.createTime) }}
                </span>
              </template>
              <!-- 操作列 -->
              <template v-else-if="column.dataIndex === 'operation'">
                <div class="table-action-buttons">
                  <a
                    @click="$refs.createForm.handleUpdate(record, undefined)"
                    v-hasPermi="['system:attendance:edit']"
                    class="edit-link"
                  >
                    编辑
                  </a>
                  <span class="action-divider">|</span>
                  <a
                    @click="handleOpenEmployeeList(record)"
                    v-hasPermi="['system:attendance:employee']"
                    class="employee-list-link"
                  >
                    员工列表
                  </a>
                </div>
              </template>
              <!-- 其他字段：默认显示 text 值 -->
              <template v-else>
                <span>{{ text }}</span>
              </template>
            </template>
          </a-table>
        </div>
        <!-- 分页 -->
        <div class="pagination-wrapper">
          <div class="pagination-left">
            <span class="pagination-info">
              显示第 {{ (queryParam.pageNum - 1) * queryParam.pageSize + 1 }} 到第
              {{ Math.min(queryParam.pageNum * queryParam.pageSize, total) }} 条数据/共 {{ total }} 条
            </span>
            <a-select
              v-model:value="queryParam.pageSize"
              style="width: 100px; margin-left: 8px"
              @change="onShowSizeChange(queryParam.pageNum, queryParam.pageSize)"
              class="no-border-radius-select"
            >
              <a-select-option :value="10">10条/页</a-select-option>
              <a-select-option :value="20">20条/页</a-select-option>
              <a-select-option :value="50">50条/页</a-select-option>
              <a-select-option :value="100">100条/页</a-select-option>
            </a-select>
          </div>
          <div class="pagination-right">
            <a-pagination
              :current="queryParam.pageNum"
              :total="total"
              :page-size="queryParam.pageSize"
              :show-total="false"
              @change="changeSize"
            />
            <span class="pagination-jump">
              到第
              <a-input-number
                v-model:value="jumpPage"
                :min="1"
                :max="Math.ceil(total / queryParam.pageSize)"
                style="width: 60px; margin: 0 4px"
                @pressEnter="handleJumpPage"
                class="no-border-radius-input-number"
              />
              页
            </span>
          </div>
        </div>
      </a-col>
    </a-row>
  </a-card>
</template>

<script>
import { $on, $off, $once, $emit } from '../../../utils/gogocodeTransfer'
import {
  SearchOutlined,
  RedoOutlined,
  UpOutlined,
  DownOutlined,
  PlusOutlined,
  DeleteOutlined,
  DownloadOutlined,
  UploadOutlined,
  CloudDownloadOutlined,
} from '@ant-design/icons-vue'
import { pageAttendance, listAttendance, delAttendance } from '@/api/system/attendance'
import CreateForm from './modules/CreateForm'
import ImportExcel from './modules/ImportExcel'
import EmployeeListModal from './modules/EmployeeListModal'
import { tableMixin } from '@/store/table-mixin'
import { parseTime } from '@/utils/ruoyi'

export default {
  name: 'Attendance',
  components: {
    SearchOutlined,
    RedoOutlined,
    UpOutlined,
    DownOutlined,
    PlusOutlined,
    DeleteOutlined,
    DownloadOutlined,
    UploadOutlined,
    CloudDownloadOutlined,
    CreateForm,
    ImportExcel,
    EmployeeListModal,
  },
  mixins: [tableMixin],
  dicts: ['is_overnight', 'working_days_rules'],
  data() {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      employeeListVisible: false,
      currentAttendanceId: null,
      jumpPage: 1,
      // 查询参数：仅保留接口所需字段及筛选项
      queryParam: {
        projectId: null, // 当前项目ID
        name: null, // 规则名称
        startTime: null, // 开始时间
        endTime: null, // 结束时间
        workingHours: null, // 每日工作时长
        isOvernight: undefined, // 是否跨天
        workRules: undefined, // 工作天数规则
        workingDays: null, // 工作天数
        pageNum: 1,
        pageSize: 10,
      },
      // 列表表头配置
      columns: [
        {
          title: '规则名称',
          dataIndex: 'name',
          align: 'center',
          width: 150,
        },
        {
          title: '开始时间',
          dataIndex: 'startTime',
          align: 'center',
          width: 120,
        },
        {
          title: '结束时间',
          dataIndex: 'endTime',
          align: 'center',
          width: 120,
        },
        {
          title: '每日工作时长(小时)',
          dataIndex: 'workingHours',
          align: 'center',
          width: 160,
        },
        {
          title: '是否跨天',
          dataIndex: 'isOvernight',
          align: 'center',
          width: 120,
        },
        {
          title: '工作天数规则',
          dataIndex: 'workRules',
          align: 'center',
          width: 150,
        },
        {
          title: '工作天数',
          dataIndex: 'workingDays',
          align: 'center',
          width: 120,
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 200,
          fixed: 'right',
          align: 'center',
        },
      ],
    }
  },
  created() {
    // 初始化时从 Vuex 获取项目ID
    const currentProjectId = this.$store.getters.currentProjectId
    if (currentProjectId) {
      this.queryParam.projectId = currentProjectId
    }
    this.getList()
    // 监听项目变化事件（只使用 $root 事件总线）
    $on(this.$root, 'project-changed', this.handleProjectChanged)
  },
  beforeUnmount() {
    // 移除事件监听
    $off(this.$root, 'project-changed', this.handleProjectChanged)
  },
  computed: {
    submitButtonStyle() {
      return this.advanced ? { float: 'left', overflow: 'hidden' } : {}
    },
    // 表格列配置（使用 computed 以便在 customRender 中访问 this）
    tableColumns() {
      const that = this
      return [
        {
          title: '序号',
          dataIndex: 'index',
          align: 'center',
          width: 80,
          customRender: ({ index }) => {
            const { pageNum, pageSize } = that.queryParam
            return (pageNum - 1) * pageSize + index + 1
          },
        },
        ...this.columns,
      ]
    },
  },
  watch: {},
  methods: {
    /** 查询考勤规则列表 */
    getList() {
      const currentProjectId = this.$store.getters.currentProjectId
      if (currentProjectId) {
        this.queryParam.projectId = currentProjectId
      }
      this.loading = true
      pageAttendance(this.queryParam)
        .then((response) => {
          this.list = response.data.records
          this.total = response.data.total
          this.jumpPage = this.queryParam.pageNum
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },

    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      // 从 Vuex 获取当前项目ID作为默认值
      const currentProjectId = this.$store.getters.currentProjectId
      this.queryParam = {
        projectId: currentProjectId || undefined,
        name: null, // 规则名称
        startTime: null, // 开始时间
        endTime: null, // 结束时间
        workingHours: null, // 每日工作时长
        isOvernight: null, // 是否跨天
        workRules: null, // 工作天数规则
        workingDays: null, // 工作天数
        pageNum: 1,
        pageSize: 10,
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.queryParam.pageNum = 1
      this.jumpPage = 1
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.jumpPage = current
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      // 判断 row 是否是行数据对象（有 id 属性且不是事件对象）
      const isRowData = row && typeof row === 'object' && 'id' in row && !('target' in row) && !('currentTarget' in row)

      const ids = isRowData ? row.id : this.ids
      if (isRowData && row.id) {
        if (!this.ids.includes(row.id)) {
          this.ids.push(row.id)
        }
      }

      // 获取要删除的规则名称
      let nameText = ''
      if (isRowData && row.name) {
        // 单行删除，显示该行的规则名称
        nameText = row.name
      } else if (this.selectedRows && this.selectedRows.length > 0) {
        // 多行删除，显示所有选中行的规则名称
        const names = this.selectedRows.map((item) => item.name).filter((name) => name)
        nameText = names.join('、')
      }

      this.$confirm({
        title: '确认删除所选中数据?',
        content: nameText ? `规则名称：${nameText}` : '确认删除所选数据?',
        onOk() {
          let data = []
          that.ids.map((id) => data.push({ id: id }))
          return delAttendance(data).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('删除成功', 3)
          })
        },
        onCancel() {
          //取消清空删除ids列表
          that.ids = []
        },
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      const hasSelection = that.selectedRowKeys && that.selectedRowKeys.length > 0
      this.$confirm({
        title: '是否确认导出?',
        content: hasSelection ? '将导出所选数据' : '此操作将导出当前条件下所有数据',
        onOk() {
          const params = { ...that.queryParam }
          if (hasSelection) {
            params.ids = that.selectedRowKeys
          }
          that.download('system/attendance/export', params, `考勤规则_${new Date().getTime()}.xlsx`)
        },
        onCancel() {},
      })
    },
    /** 下载模板按钮操作 */
    handleImportTemplate() {
      this.download('system/attendance/importTemplate', {}, `考勤规则导入模板_${new Date().getTime()}.xls`)
    },
    /** 处理项目变化 */
    handleProjectChanged(projectId) {
      // 更新查询参数中的项目ID
      this.queryParam.projectId = projectId
      // 重置到第一页并刷新列表
      this.queryParam.pageNum = 1
      this.getList()
    },
    handleOpenEmployeeList(record) {
      this.currentAttendanceId = record?.id || null
      this.employeeListVisible = true
    },
    /**
     * 将时间格式化为 HH:mm 显示
     */
    formatTime(value) {
      if (!value) {
        return '-'
      }
      const parts = value.split(':')
      if (parts.length < 2) {
        return value
      }
      const hh = parts[0].padStart(2, '0')
      const mm = parts[1].padStart(2, '0')
      return `${hh}:${mm}`
    },
    /** 跳转到指定页码 */
    handleJumpPage() {
      if (this.jumpPage && this.jumpPage >= 1) {
        const maxPage = Math.ceil(this.total / this.queryParam.pageSize)
        if (this.jumpPage > maxPage) {
          this.jumpPage = maxPage
        }
        this.queryParam.pageNum = this.jumpPage
        this.getList()
      }
    },
  },
}
</script>

<style scoped>
/* 条件搜索区域样式 */
.table-page-search-wrapper :deep(.ant-form-item-label) {
  width: 80px;
  min-width: 80px;
  flex: 0 0 80px !important;
  max-width: 80px !important;
}

.table-page-search-wrapper :deep(.ant-form-item-label > label) {
  width: 100%;
  text-align: right;
}

/* 去掉"每日工作时长"和"工作天数规则"label后面的冒号 */
.table-page-search-wrapper :deep(.ant-form-item[prop='workingHours'] .ant-form-item-label > label::after),
.table-page-search-wrapper :deep(.ant-form-item[prop='workRules'] .ant-form-item-label > label::after) {
  content: none !important;
}

/* 确保表单项布局正确 */
.table-page-search-wrapper :deep(.ant-form-item) {
  display: flex;
  align-items: center;
  width: 100%;
}

.table-page-search-wrapper :deep(.ant-form-item-row) {
  flex-wrap: nowrap;
}

.table-page-search-wrapper :deep(.ant-form-item-control-wrapper) {
  flex: 1 1 0 !important;
  max-width: none !important;
  margin-left: 8px;
  min-width: 0;
}

.table-page-search-wrapper :deep(.ant-form-item-control-input),
.table-page-search-wrapper :deep(.ant-form-item-control-input-content) {
  width: 100%;
  min-width: 0;
}

/* 移除所有输入框圆角的通用样式 */
.no-border-radius-input :deep(.ant-input) {
  border-radius: 0 !important;
}

.no-border-radius-input :deep(.ant-input-affix-wrapper) {
  border-radius: 0 !important;
}

.no-border-radius-picker :deep(.ant-picker) {
  border-radius: 0 !important;
}

.no-border-radius-select :deep(.ant-select-selector) {
  border-radius: 0 !important;
}

.no-border-radius-input-number :deep(.ant-input-number) {
  border-radius: 0 !important;
}

.no-border-radius-input-number :deep(.ant-input-number-input) {
  border-radius: 0 !important;
}

/* 搜索区域输入框样式覆盖 - 优先级高于 no-border-radius-input */
/* 普通输入框样式 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input),
.table-page-search-wrapper :deep(.ant-form-item-control-input .ant-input) {
  width: 100% !important;
  max-width: 260px;
  background: #ffffff !important;
  border-radius: 4px !important;
  border: 1px solid #c7c7c7 !important;
}

.table-page-search-wrapper.is-collapsed :deep(.no-border-radius-input .ant-input),
.table-page-search-wrapper.is-collapsed :deep(.ant-form-item-control-input .ant-input) {
  max-width: none !important;
}

/* 带前缀/后缀的输入框外层样式 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper) {
  width: 100% !important;
  max-width: 260px;
  background: #ffffff !important;
  border-radius: 4px !important;
  border: 1px solid #c7c7c7 !important;
}

.table-page-search-wrapper.is-collapsed :deep(.no-border-radius-input .ant-input-affix-wrapper),
.table-page-search-wrapper.is-collapsed :deep(.ant-input-affix-wrapper) {
  max-width: none !important;
}

/* 带前缀/后缀的输入框内部input去掉边框，避免嵌套 */
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper > .ant-input),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper .ant-input),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper > .ant-input),
.table-page-search-wrapper :deep(.ant-form-item .ant-input-affix-wrapper .ant-input),
.table-page-search-wrapper :deep(.ant-form-item-control-input-content .ant-input-affix-wrapper .ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input:hover),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input:focus),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input-focused),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper-focused .ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper-focused .ant-input:focus),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper .ant-input:hover),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper .ant-input:focus),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper .ant-input-focused),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper input.ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input:not(:focus):not(:hover)),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input[type='text']) {
  border: 0 !important;
  border-top: 0 !important;
  border-right: 0 !important;
  border-bottom: 0 !important;
  border-left: 0 !important;
  border-width: 0 !important;
  border-style: none !important;
  border-color: transparent !important;
  background: transparent !important;
  background-color: transparent !important;
  box-shadow: none !important;
  outline: none !important;
  width: 100% !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
}

/* 日期选择器样式 */
.table-page-search-wrapper :deep(.no-border-radius-picker .ant-picker),
.table-page-search-wrapper :deep(.ant-picker) {
  width: 100% !important;
  min-width: 0;
  max-width: 260px;
  background: #ffffff !important;
  border-radius: 4px !important;
  border: 1px solid #c7c7c7 !important;
}

.table-page-search-wrapper.is-collapsed :deep(.no-border-radius-picker .ant-picker),
.table-page-search-wrapper.is-collapsed :deep(.ant-picker) {
  max-width: none !important;
}

/* 下拉选择框样式 */
.table-page-search-wrapper :deep(.no-border-radius-select .ant-select-selector),
.table-page-search-wrapper :deep(.ant-select-selector) {
  width: 100% !important;
  min-width: 0;
  max-width: 260px;
  background: #ffffff !important;
  border-radius: 4px !important;
  border: 1px solid #c7c7c7 !important;
}

.table-page-search-wrapper.is-collapsed :deep(.no-border-radius-select .ant-select-selector),
.table-page-search-wrapper.is-collapsed :deep(.ant-select-selector) {
  max-width: none !important;
}

/* 下拉选择框容器样式 */
.table-page-search-wrapper :deep(.no-border-radius-select.ant-select),
.table-page-search-wrapper :deep(.ant-select) {
  width: 100% !important;
  min-width: 0;
  max-width: 260px;
}

.table-page-search-wrapper.is-collapsed :deep(.no-border-radius-select.ant-select),
.table-page-search-wrapper.is-collapsed :deep(.ant-select) {
  max-width: none !important;
}

.table-page-search-wrapper :deep(.ant-input-number) {
  width: 100% !important;
  max-width: 260px;
  border-radius: 4px 4px 4px 4px !important;
  border: 1px solid #c7c7c7 !important;
}

.table-page-search-wrapper.is-collapsed :deep(.ant-input-number) {
  max-width: none !important;
}

.table-page-search-wrapper :deep(.ant-input-number) {
  border-radius: 0 !important;
}

/* 搜索区域数字输入框样式 */
.table-page-search-wrapper :deep(.no-border-radius-input-number.ant-input-number),
.table-page-search-wrapper :deep(.no-border-radius-input-number) {
  border-radius: 4px !important;
  border: 1px solid #c7c7c7 !important;
}

/* 移除搜索栏输入框、下拉选择框、日期选择框聚焦时的高亮效果 */
/* 输入框聚焦样式 - 内部input隐藏边框 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input:focus),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-focused),
.table-page-search-wrapper :deep(.ant-input:focus),
.table-page-search-wrapper :deep(.ant-input-focused) {
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 带前缀/后缀的输入框聚焦样式 - 外部容器保持边框，内部input隐藏边框 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper:focus),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper-focused),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper:focus),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper-focused) {
  border: 1px solid #c7c7c7 !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 聚焦时，内部input隐藏边框 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper:focus .ant-input),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper-focused .ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper:focus .ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper-focused .ant-input) {
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 下拉选择框聚焦样式 */
.table-page-search-wrapper :deep(.no-border-radius-select .ant-select-selector:focus),
.table-page-search-wrapper :deep(.no-border-radius-select .ant-select-focused .ant-select-selector),
.table-page-search-wrapper :deep(.ant-select-selector:focus),
.table-page-search-wrapper :deep(.ant-select-focused .ant-select-selector) {
  border: 1px solid #c7c7c7 !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 日期选择框聚焦样式 */
.table-page-search-wrapper :deep(.no-border-radius-picker .ant-picker:focus),
.table-page-search-wrapper :deep(.no-border-radius-picker .ant-picker-focused),
.table-page-search-wrapper :deep(.ant-picker:focus),
.table-page-search-wrapper :deep(.ant-picker-focused) {
  border: 1px solid #c7c7c7 !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 搜索按钮和新增按钮样式 */
.search-button,
.add-button {
  background-color: #165dff !important;
  border-color: #165dff !important;
  border-radius: 4px !important;
}

.search-button:hover,
.add-button:hover {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
}

.search-button:focus,
.add-button:focus {
  background-color: #165dff !important;
  border-color: #165dff !important;
}

/* 其他按钮圆角设置 */
.table-page-search-wrapper :deep(.ant-btn) {
  border-radius: 4px;
}

.table-operations :deep(.ant-btn) {
  border-radius: 4px;
}

/* 全局按钮圆角设置 */
:deep(.ant-btn) {
  border-radius: 4px !important;
}

.table-action-buttons a {
  color: #1890ff;
  cursor: pointer;
  white-space: nowrap; /* 防止操作按钮换行 */
}

.table-action-buttons a:hover {
  color: #40a9ff;
}

/* 编辑按钮颜色 */
.table-action-buttons .edit-link {
  color: #165dff !important;
}

.table-action-buttons .edit-link:hover {
  color: #4080ff !important;
}

/* 员工列表按钮颜色 */
.table-action-buttons .employee-list-link {
  color: #333333 !important;
}

.table-action-buttons .employee-list-link:hover {
  color: #595959 !important;
}

.action-divider {
  margin: 0 8px;
  color: #d9d9d9;
  white-space: nowrap;
}

/* 去掉指定按钮的边框 */
.no-border-button {
  border: none !important;
  background: #f3f3f3 !important;
  color: #101010 !important;
}

.no-border-button:hover,
.no-border-button:focus {
  border: none !important;
  background: #f3f3f3 !important;
  color: #101010 !important;
}

/* 删除按钮禁用状态样式 */
.no-border-button[disabled] {
  background-color: #f5f5f5 !important;
  color: rgba(0, 0, 0, 0.25) !important;
  cursor: not-allowed !important;
}

.no-border-button[disabled]:hover,
.no-border-button[disabled]:focus {
  background-color: #f5f5f5 !important;
  border: none !important;
  color: rgba(0, 0, 0, 0.25) !important;
  cursor: not-allowed !important;
}

/* 导入导出按钮背景颜色 */
.import-export-button {
  background: #f3f3f3 !important;
  color: #333 !important;
}

.import-export-button :deep(.anticon) {
  color: #333 !important;
}

.import-export-button:hover,
.import-export-button:focus {
  background: #f3f3f3 !important;
  color: #333 !important;
}

.import-export-button:hover :deep(.anticon),
.import-export-button:focus :deep(.anticon) {
  color: #333 !important;
}

/* 展开/收起按钮文字和图标颜色，去掉底部阴影 */
.toggle-button {
  background: transparent !important;
  color: #165dff !important;
  box-shadow: none !important;
}

/* 导入模板下载按钮文字和图标颜色，去掉底部阴影 */
.template-download-button {
  background: transparent !important;
  color: #165dff !important;
  box-shadow: none !important;
}

.template-download-button :deep(.anticon) {
  color: #165dff !important;
}

.template-download-button:hover,
.template-download-button:focus {
  background: transparent !important;
  color: #165dff !important;
  box-shadow: none !important;
}

.template-download-button:hover :deep(.anticon),
.template-download-button:focus :deep(.anticon) {
  color: #165dff !important;
}

.toggle-button :deep(.anticon) {
  color: #165dff !important;
}

.toggle-button:hover,
.toggle-button:focus {
  background: transparent !important;
  color: #165dff !important;
  box-shadow: none !important;
}

.toggle-button:hover :deep(.anticon),
.toggle-button:focus :deep(.anticon) {
  color: #165dff !important;
}

.table-page-search-wrapper {
  margin-bottom: 16px;
}

/* 按钮区域样式 */
.table-page-search-submitButtons {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.search-actions-col {
  display: flex;
  justify-content: flex-end;
}

.search-actions-group {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

@media (max-width: 992px) {
  .table-page-search-wrapper :deep(.ant-form-item-row) {
    flex-wrap: wrap;
  }

  .table-page-search-wrapper :deep(.ant-form-item-label) {
    width: auto;
    min-width: 0;
    flex: 0 0 auto !important;
    max-width: none !important;
  }

  .table-page-search-wrapper :deep(.ant-form-item-label > label) {
    width: auto;
    text-align: left;
  }

  .table-page-search-wrapper :deep(.ant-form-item-control-wrapper) {
    flex: 1 1 100% !important;
    max-width: none !important;
    margin-left: 0;
  }

  .search-actions-col {
    justify-content: flex-start;
  }
}

.table-operations {
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.refresh-icon-button {
  width: 32px;
  height: 32px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pagination-wrapper {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.pagination-left {
  display: flex;
  align-items: center;
}

.pagination-info {
  color: rgba(0, 0, 0, 0.65);
}

.pagination-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

.pagination-jump {
  display: flex;
  align-items: center;
  color: rgba(0, 0, 0, 0.65);
}

/* 分页组件样式 - 去掉圆角 */
.pagination-wrapper :deep(.ant-btn) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-pagination-item) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-pagination-prev),
.pagination-wrapper :deep(.ant-pagination-next),
.pagination-wrapper :deep(.ant-pagination-prev .ant-pagination-item-link),
.pagination-wrapper :deep(.ant-pagination-next .ant-pagination-item-link) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-pagination-prev button),
.pagination-wrapper :deep(.ant-pagination-next button) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-input-number) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-input-number-input) {
  border-radius: 0 !important;
}

/* 分页选中页数样式 */
.pagination-wrapper :deep(.ant-pagination-item-active) {
  background: #165dff !important;
  border-color: #165dff !important;
  border-radius: 4px !important;
}

.pagination-wrapper :deep(.ant-pagination-item-active a) {
  color: #ffffff !important;
}

.pagination-wrapper :deep(.ant-pagination-item-active:hover) {
  background: #165dff !important;
  border-color: #165dff !important;
}

.pagination-wrapper :deep(.ant-pagination-item-active:hover a) {
  color: #ffffff !important;
}

/* 优化表格样式 */
.optimized-table :deep(.ant-table-thead > tr > th) {
  white-space: nowrap; /* 表头不换行 */
  overflow: hidden;
  text-overflow: ellipsis;
  background-color: #fafafa;
  font-family: PingFang SC, PingFang SC;
  font-weight: bold;
  font-size: 14px;
  color: #333333;
}

.optimized-table :deep(.ant-table-tbody > tr > td) {
  white-space: nowrap; /* 表格内容不换行 */
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 12px 8px; /* 增加内边距 */
  font-family: PingFang SC, PingFang SC !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: #333333 !important;
}

/* 操作列固定右侧样式 */
.optimized-table :deep(.ant-table-tbody > tr > td:last-child) {
  position: sticky;
  right: 0;
  background: white;
  z-index: 12;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.05);
}

.optimized-table :deep(.ant-table-tbody > tr.ant-table-row-selected > td:last-child) {
  position: sticky;
  right: 0;
  background: white !important;
  z-index: 12;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.05);
}

.optimized-table :deep(.ant-table-tbody > tr.ant-table-row-selected:hover > td:last-child) {
  position: sticky;
  right: 0;
  background: #f5f5f5 !important;
  z-index: 12;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.05);
}

.optimized-table :deep(.ant-table-thead > tr > th:last-child) {
  position: sticky;
  right: 0;
  background: #fafafa;
  z-index: 11;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.05);
}

/* 行悬停效果 */
.optimized-table :deep(.ant-table-tbody > tr:hover > td) {
  background-color: #f5f5f5;
}

/* 去掉表格边框 */
:deep(.ant-table) {
  border: none !important;
}

:deep(.ant-table-container) {
  border: none !important;
}

:deep(.ant-table-thead > tr > th) {
  border-bottom: 1px solid #f0f0f0 !important;
  border-right: none !important;
}

:deep(.ant-table-thead > tr > th:first-child) {
  border-left: none !important;
}

:deep(.ant-table-tbody > tr > td) {
  border-bottom: 1px solid #f0f0f0 !important;
  border-right: none !important;
}

:deep(.ant-table-tbody > tr > td:first-child) {
  border-left: none !important;
}

:deep(.ant-table-tbody > tr:last-child > td) {
  border-bottom: none !important;
}

/* 表格滚动条样式优化 */
:deep(.ant-table-body) {
  overflow-x: auto !important;
  scrollbar-width: thin;
  scrollbar-color: #d9d9d9 #f5f5f5;
}

:deep(.ant-table-body::-webkit-scrollbar) {
  height: 8px;
}

:deep(.ant-table-body::-webkit-scrollbar-track) {
  background: #f5f5f5;
  border-radius: 4px;
}

:deep(.ant-table-body::-webkit-scrollbar-thumb) {
  background: #d9d9d9;
  border-radius: 4px;
}

:deep(.ant-table-body::-webkit-scrollbar-thumb:hover) {
  background: #bfbfbf;
}

/* 序号列样式优化 */
:deep(.ant-table-tbody > tr > td:first-child) {
  font-family: PingFang SC, PingFang SC !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: #333333 !important;
}

/* 选中的行样式 - 去掉背景色 */
:deep(.ant-table-tbody > tr.ant-table-row-selected > td) {
  background-color: transparent !important;
}

:deep(.ant-table-tbody > tr.ant-table-row-selected:hover > td) {
  background-color: transparent !important;
}

/* 表格复选框样式 */
.optimized-table :deep(.ant-checkbox-inner) {
  width: 16px !important;
  height: 16px !important;
  border-radius: 0 !important;
  border-color: #999999 !important;
}

.optimized-table :deep(.ant-checkbox-checked .ant-checkbox-inner) {
  background-color: #165dff !important;
  border-color: #165dff !important;
}

.optimized-table :deep(.ant-checkbox-checked .ant-checkbox-inner::after) {
  border-color: #ffffff !important;
}

.optimized-table :deep(.ant-checkbox:hover .ant-checkbox-inner) {
  border-color: #165dff !important;
}

.optimized-table :deep(.ant-checkbox-input:focus + .ant-checkbox-inner) {
  border-color: #165dff !important;
}

.optimized-table :deep(.ant-checkbox-checked:hover .ant-checkbox-inner) {
  background-color: #165dff !important;
  border-color: #165dff !important;
}

/* 表格复选框列固定左侧样式 */
.optimized-table :deep(.ant-table-thead > tr > th:first-child) {
  position: sticky;
  left: 0;
  background: #fafafa;
  z-index: 12;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.05);
}

.optimized-table :deep(.ant-table-tbody > tr > td:first-child) {
  position: sticky;
  left: 0;
  background: white;
  z-index: 11;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.05);
}

.optimized-table :deep(.ant-table-tbody > tr.ant-table-row-selected > td:first-child) {
  position: sticky;
  left: 0;
  background: white !important;
  z-index: 11;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.05);
}

.optimized-table :deep(.ant-table-tbody > tr.ant-table-row-selected:hover > td:first-child) {
  position: sticky;
  left: 0;
  background: #f5f5f5 !important;
  z-index: 11;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.05);
}

/* 复选框列中的复选框层级 */
.optimized-table :deep(.ant-table-thead > tr > th:first-child .ant-checkbox-wrapper),
.optimized-table :deep(.ant-table-tbody > tr > td:first-child .ant-checkbox-wrapper) {
  position: relative;
  z-index: 13;
}

.optimized-table :deep(.ant-table-thead > tr > th:first-child .ant-checkbox),
.optimized-table :deep(.ant-table-tbody > tr > td:first-child .ant-checkbox) {
  position: relative;
  z-index: 13;
}

.optimized-table :deep(.ant-table-thead > tr > th:first-child .ant-checkbox-inner),
.optimized-table :deep(.ant-table-tbody > tr > td:first-child .ant-checkbox-inner) {
  position: relative;
  z-index: 13;
}

/* Confirm 弹窗按钮样式 */
:deep(.ant-modal-confirm .ant-btn) {
  border-radius: 4px !important;
}

:deep(.ant-modal-confirm .ant-btn-default) {
  border-radius: 4px !important;
}

:deep(.ant-modal-confirm .ant-btn-primary) {
  background-color: #165dff !important;
  border-color: #165dff !important;
  border-radius: 4px !important;
  color: #ffffff !important;
}

:deep(.ant-modal-confirm .ant-btn-primary:hover:not(:disabled)) {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
  color: #ffffff !important;
}

:deep(.ant-modal-confirm .ant-btn-primary:focus:not(:disabled)) {
  background-color: #165dff !important;
  border-color: #165dff !important;
  color: #ffffff !important;
}

:deep(.ant-modal-confirm .ant-btn-primary:active:not(:disabled)) {
  background-color: #165dff !important;
  border-color: #165dff !important;
  color: #ffffff !important;
}
</style>

<style>
/* Confirm 弹窗按钮样式 - 全局样式确保生效（confirm弹窗是动态创建的） */
.ant-modal-confirm .ant-modal-confirm-btns .ant-btn {
  border-radius: 4px !important;
}

.ant-modal-confirm .ant-modal-confirm-btns .ant-btn-default {
  border-radius: 4px !important;
}

.ant-modal-confirm .ant-modal-confirm-btns .ant-btn-primary {
  background-color: #165dff !important;
  border-color: #165dff !important;
  border-radius: 4px !important;
  color: #ffffff !important;
}

.ant-modal-confirm .ant-modal-confirm-btns .ant-btn-primary:hover:not(:disabled) {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
  color: #ffffff !important;
}

.ant-modal-confirm .ant-modal-confirm-btns .ant-btn-primary:focus:not(:disabled) {
  background-color: #165dff !important;
  border-color: #165dff !important;
  color: #ffffff !important;
}

.ant-modal-confirm .ant-modal-confirm-btns .ant-btn-primary:active:not(:disabled) {
  background-color: #165dff !important;
  border-color: #165dff !important;
  color: #ffffff !important;
}
</style>
